import { Inject, inject, Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { BsModalService } from 'ngx-bootstrap/modal';
import { RequestVersionUpdateComponent } from '../../components/request-version-update/request-version-update.component';
import { filter, tap, withLatestFrom } from 'rxjs/operators';
import { ModalClass } from '../../enums/modal-bootstrap-classes.enum';
import { Observable, of } from 'rxjs';
import { EventService } from '../event/event.service';
import { LogInstanceToken, LogInterface, PaceInsightsService } from '@evorait/pace-logging';

@Injectable({
    providedIn: 'root',
})
export class AppUpdateService {
    private paceInsightsService = inject(PaceInsightsService);
    public constructor(
        private readonly updates: SwUpdate,
        private readonly modalService: BsModalService,
        private readonly eventService: EventService,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
    ) {}

    public checkForUpdates(): void {
        if (this.updates.isEnabled) {
            this.updates.checkForUpdate().catch((err) => {
                this.log.warn('Error while checking for app updates', err);
            });
        }
    }

    public init(): Observable<void> {
        this.updates.versionUpdates
            .pipe(
                filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
                tap((evt) => {
                    this.log.info('new version found', { evt });
                }),
                withLatestFrom(this.eventService.appInitializationCompleted$),
            )
            .subscribe(([, initializationCompleted]) => {
                // checks if PACE is initialized if not yet, directly restarts to update SW
                if (initializationCompleted) {
                    this.showRequestVersionUpdateModal();
                } else {
                    this.paceInsightsService.trackEvent('reload page for app update without user confirmation');
                    this.reloadPage();
                }
            });

        return of(undefined);
    }

    protected reloadPage(): void {
        window.location.reload();
    }

    private showRequestVersionUpdateModal(): void {
        this.paceInsightsService.trackEvent('Raise RequestVersionUpdate Modal');
        this.modalService.show(RequestVersionUpdateComponent, {
            class: ModalClass.MODAL_SMALL,
            ariaLabelledBy: 'request-version-update-modal-title',
        });
    }
}
